module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/NuqC4Z/tc-custom/9781429919913.jpg?1737764323181",
      "alt": "This image is the cover for the book 2012"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("2012\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v(" December 21, 2012, may be one of the most watched dates in history. Every 26,000 years, Earth lines up with the exact center of our galaxy. At 11:11 on December 21, 2012, this event happens again, and the ancient Maya calculated that it would mark the end, not only of this age, but of human consciousness as we know it."), _c('br'), _c('br'), _vm._v(" But what will actually happen? The end of the world? A new age for mankind? Nothing? The last time this happened, Cro-Magnon man suddenly began creating great art in the caves of southern France, which to this day remains one of the most inexplicable changes in human history."), _c('br'), _c('br'), _vm._v(" Now Whitley Strieber explores 2012 in a towering work of fiction that will astound readers with its truly new insights and a riveting roller-coaster ride of a story. A mysterious alien presence unexpectedly bursts out of sacred sites all over the world and begins to rip human souls from their bodies, plunging the world into chaos it has never before known."), _c('br'), _c('br'), _vm._v(" Courage meets cowardice, loyalty meets betrayal as an entire world struggles to survive this incredible end-all war. Heroes emerge, villains reveal themselves, and in the end something completely new and unexpected happens that at once lifts the fictional characters into a new life, and sounds a haunting real-world warning for the future. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Whitley Strieber\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Tom Doherty Associates\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0